/**
 * 
 * key
 * 
 */


const key = 'cG9zdENybU9uSG9sZA=='

export default key 